import React, { useState, useMemo, useEffect, memo } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CompanyActions } from '../../../store/actions/companies';
import { UserActions } from '../../../store/actions/users';

import webchat from '../../../assets/images/webchat_icon.svg';
import messenger from '../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../assets/images/whatsapp_icon.svg';
import instagram from '../../../assets/images/instagram_icon.svg';

import ModalCreatePackageAdd from '../Plan/Modal/ModalCreatePackageAdd';

import './ActualPlan.css';

function ActualPlan(props) {
  const { viewPage, setViewPage, company } = props;
  const [companyState, setCompanyState] = useState(company?.plan);

  useEffect(() => {
    setCompanyState(company?.plan);
  }, [company]);

  const isView = useMemo(() => {
    return viewPage === 'view';
  }, [viewPage]);

  const channelsIcon = (channel) => {
    const channels = {
      webchat,
      messenger,
      whatsapp,
      instagram,
    };
    return channels[channel];
  };

  const handleTextChannel = (channel) => {
    let text = '';

    if (companyState.name.toLowerCase() === 'starter') {
      if (channel === 'whatsapp') {
        text = `${companyState?.amountWhatsappConversation}/mês`;
      } else if (channel === 'messenger') {
        text = 'Ilimitado';
      } else {
        text = 'Ilimitado';
      }

      return text;
    }
    if (companyState.name.toLowerCase() === 'freemium') {
      text = '1000/mês';
      return text;
    }

    return channel === 'whatsapp'
      ? `${companyState?.amountWhatsappConversation}/mês`
      : 'Ilimitado';
  };

  return (
    <div
      className={
        isView
          ? 'w-100-per-cent plan-container description-plan-container'
          : 'plan-container description-plan-container'
      }
    >
      <div className="w-100-actual-plan">
        <div className="user-actual-plan">
          <p className="user-plan-title">Plano</p>
          <div className="container-corporate">
            <p>{companyState?.name}</p>
            {!isView && (
              <button type="button" onClick={() => setViewPage('view')}>
                mudar plano
              </button>
            )}
          </div>
        </div>

        <div className="divider-plan-actual-plan" />

        <div className="infos-messages">
          <div className="franchise-messages">
            <div key="channel" className="messages-franchise">
              <div className="icon-channel-messages">
                {companyState.availableChannels?.map((channel) => (
                  <div key={channel}>
                    <img
                      src={channelsIcon(channel)}
                      alt=""
                      className="img-item-limit"
                    />
                    {handleTextChannel(channel)}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="createPackageAdd"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="createPackageAdd"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <ModalCreatePackageAdd company={companyState} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  company: state.companies.company,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...CompanyActions, ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(ActualPlan))
);
